export const ApiUrls = {
  getFolders: '/api/Folder/getList',
  getFiles: '/api/File/getList',
  getFileById: '/api/File/getfileById',
  getFileByPath: '/api/File/getByPath',
  deleteFile: '/api/File/deletefile/',
  updateFile: '/api/File/updatefile',
  getMyFolders: '/api/Folder/getMyFolders',
  getFolderSharedByUser: '/api/Folder/getSharedByUser',
  getFoldersSharedWithUser: '/api/Folder/getSharedWithUser',
  getMyFiles: '/api/file/getMyFiles',
  getFilesSharedByUser: '/api/File/getSharedByUser',
  getFilesSharedWithUser: '/api/File/getSharedWithUser',
  createFolderPermission: '/api/Folder/createFolderPermission',
  createFilePermission: '/api/File/createFilePermission',
  upload: '/api/File/upload',
  reupload: '/api/File/UpdateuploadedFile',
  reuploadFile: '/api/File/reuploadFile',
  download: '/api/File/download',
  delete: '/api/File/delete',
  uploadFile: '/api/File/uploadFile',
  getFileFromCloud: '/api/File/GetFileFromCloud/',
  checkDuplicateFileNames: '/api/File/check-duplicate-names',
  // Resumable Upload URLs
  initializeResumableUpload: '/api/ResumableUpload/initialize',
  uploadChunk: '/api/ResumableUpload/chunk',
  verifyResumableUpload: '/api/ResumableUpload/verify',
  getIncompleteResumableUploads: '/api/ResumableUpload/incomplete',
  pauseResumableUpload: '/api/ResumableUpload/session',
  registerResumableUploadBatch: '/api/ResumableUpload/register-batch',
  getPendingChunks: '/api/ResumableUpload/session',
  getFolderById: '/api/Folder/getById/',
  updateFolder: '/api/Folder/update/',
  //NEW URLS
  createReportAgrMou: '/api/Document/CreateReport',
  createReportPom: '/api/Document/CreateReportPom',

  searchAgrMou: '/api/Document/SearchInAgreementAndMemorandums',
  searchPom: '/api/Document/SearchInParticipationMinute',
  createFilter: '/api/Document/CreateFilter',
  deleteFilter: '/api/Document/DeleteFilter',
  getFilter: '/api/Document/GetFilters/',
  downloadReport: '/api/Document/ExportReport',
  getMyFoldersNames: '/api/Folder/GetMyFolders',
  createFolder: '/api/Folder/create',
  // updateFolder: '/api/Folder/update',
  deleteFolder: '/api/Folder/delete/',
  getfilesinfolder: '/api/Folder/GetAllFileFolders',
  deleteFileFromFolder: '/api/Folder/DeleteFileFromFolder',
  getAllFavourites: '/api/Document/GetAllFavourites',
  deleteFromFavourites: '/api/Document/DeleteFavourites',
  saveDocToFavourite: '/api/Document/SaveDocumentToFavourites',
  uploadai: '/api/DocumentProcessing/upload',
  getAllDocByType: '/api/Document/GetAllDocByType',
  getOutbox: '/api/WorkFlowDetails/GetPersonalOutbox',
  transferDocownership: '/api/WorkFlowDetails/TransferDocumentOwnership',
  getInbox: '/api/WorkFlowDetails/GetPersonalInbox',
  saveDocToFolder: '/api/Folder/CreateFileFolder',
  exportInbox: '/api/WorkFlowDetails/ExportInboxData',
  getAdminInbox: '/api/WorkFlowDetails/GetAdminInbox',
  getAdminOutbox: '/api/WorkFlowDetails/GetAdminOutbox',
  getEmployeeInbox: '/api/WorkFlowDetails/GetEmployeeInbox',
  saveToDraft: '/api/Document/SaveToDraft',
  getSavedDocuments: '/api/Document/GetSavedDocuments',
  renameSavedDocument: '/api/Document/RenameSavedDocument',
  getFileDetails: '/api/Document/GetFileDetails',
  getSavedDocumentFromCloud: '/api/Document/GetSavedDocumentFromCloud',
  getSavedDocumentPreviewPdf: '/api/Document/GetSavedDocumentPreviewPdf',
  getSavedDocumentExport: '/api/Document/GetSavedDocumentExport',
  getNextDocumentNumbers: '/api/Document/GetNextDocumentNumbers',
  getCreateDocumentLookups: '/api/Document/GetCreateDocumentLookups',
  deleteSavedDocumentAttachment: '/api/Document/DeleteSavedDocumentAttachment',
  uploadDocumentAttachment: '/api/Document/UploadDocumentAttachment',
  deleteSavedDocument: '/api/Document/DeleteSavedDocument',
  getDraftData: '/api/Document/GetDraftData/',
  GetTasksByUser: '/api/Meeting/GetTasksByUser',
  UpdateTaskByUser: '/api/Meeting/UpdateTaskByUser',
  retryAIProcessing: '/api/DocumentProcessing/RetryAiProcessing',
  documentSoftDelete: '/api/DocumentProcessing/SoftDeleteDocumentProcessing',
  getDraftDataById: '/api/Document/GetDraftApplicationDetails/',
  createDocument: '/api/Document/CreateDocument',
  getSubjectByDocType: '/api/Document/GetSubjectsByDocumentType',
  getSelectedDocId: '/api/Document/GetSubjectsByDocumentTypeBrowse',
  getSubjectDraftByDocType: '/api/Document/GetSubjectsDraftByDocumentType',
  getUploadedAttachments: '/api/DocumentProcessing/getUploadedAttachments',
  getUploadedPomReportAttachments:
    '/api/DocumentProcessing/getUploadedPomReportAttachments',
  getDraftDocuments: '/api/Document/GetDraftApplications',
  deleteDraftDocuments: '/api/Document/deleteDarftDocument',
  getDocumentObservation: '/api/Document/GetObservations',
  addUpdateObservation: '/api/Document/CreateObservations',
  addUpdateLatestDevelopment: '/api/Document/CreateLatestDevelopment',
  getLatestDevelopment: '/api/Document/GetDevelopements',
  CalenderMeetings: '/api/Meeting/CalendarMeetings',
  getAllDocuments: '/api/Document/GetAllDocument',
  deleteObservation: '/api/Document/DeleteObservations',
  deleteLatestDevelopment: '/api/Document/DeleteLatestDevelopment',
  GetMeetingParticipants: '/api/Meeting/GetParticipantNames',
  createTasks: '/api/Meeting/CreateRecommendations',
  documentLogs: '/api/Document/GetLogHistoryFile',
  taskLogs: '/api/Document/GetTaskHistoryFile',
  workflowLog: '/api/WorkFlowDetails/GetWorkflowLogs',
  uploadUpdateAttachment: '/api/DocumentProcessing/UploadUpdateAttachment',
  uploadUpdatePomReport: '/api/DocumentProcessing/UploadUpdatePomReport',
  getAllDocAttachment: '/api/DocumentProcessing/getAllDocAttachments',
  getAllDocPomReport: '/api/DocumentProcessing/getAllPomReportAttachments',
  deleteDocAttachment: '/api/DocumentProcessing/DeleteAttachment',
  deleteDocPomReport: '/api/DocumentProcessing/DeletePomReportAttachment',
  getAllSelected: '/api/Document/GetAllSubjects',
  participationNumberListOnSubject:
    '/api/Document/ParticipationNumberListOnSubject',
  getSelectedSubject: '/api/Document/GetDocSubjectsOfUser',
  getTaskListByDocId: '/api/Meeting/GetTasksByDocumentId',
  deleteDocument: '/api/Document/deleteDocument',
  getDeletedDocuments: '/api/Document/GetAllDeletedDocuments',
  restoreDocument: '/api/Document/RestoreDocument',
  getSharedDocument: '/api/Share/sharedDocuments',
  getSharedDocumentIds: '/api/Share/sharedDocumentIds',
  getSharedUsers: '/api/Share/shared-users',
  shareDocument: '/api/Share/shareDocument',
  revokeShareDocument: '/api/Share/revertSharedDocument',
  getDocumentSharedTemplates: '/api/Template/getDocumentSharedTemplates',
  updateDocument: '/api/Document/UpdateDocumentWithWorkflow',
  documentTranslation: '/api/Document/GetTranslationDetails',
  saveTranslation: '/api/Document/ProcessTranslationWorkflow',
  customPomReportUpload: '/api/DocumentProcessing/UploadPomReportWithTemplate',
  getPOMReportTemplate: '/api/Template/getPOMReportTemplate',
  translateDoc: '/api/Document/TranslateDocument',
  GetDocumentWorkflowRecord: '/api/WorkFlowDetails/GetWorkflowRecords',
  GetTopNotifications: '/api/WorkflowAction/GetTopNotifications',
  exportLogData: '/api/WorkFlowDetails/ExportLogData',
  exportdevelopment: '/api/WorkFlowDetails/ExportDevelopments',
  sharedevelopment: '/api/WorkFlowDetails/ShareDevelopmentsReport',
  shareIdentificationCard: '/api/WorkFlowDetails/ShareIdentificationcard',
  downloadDocument: '/api/Document/DownloadDocument',
  shareAdminInbox: '/api/WorkFlowDetails/ShareAdminInboxData',
  sharePersonalInbox: '/api/WorkFlowDetails/SharePersonalInboxData',
  shareReport: '/api/Document/ShareReport',
  saveLiaisonOfficers: '/api/Document/SaveLiaisonOfficers',
  saveParticipants: '/api/Document/SavePartcipantNames',
  getLiaisonOfficerById: '/api/Document/GetLiaisonOfficerByDocumentId',
  getParticipantsById: '/api/Document/GetParticipationNameByDocumentId',
  transferFileToFolder: '/api/File/MoveFilesToFolder',
  moveFolder: '/api/Folder/MoveFolder',
  duplicateFile: '/api/File/duplicate',
  duplicateFolder: '/api/Folder/duplicate',
  downloadIdentificationCard: '/api/Document/ExportIdentificationCard',
  updateIdCard: '/api/Document/UpdateIdentificationCard',
  getIdCardByDocId: '/api/Document/GetIdentificationCard',
  getDocumentProcessingStatus:
    '/api/DocumentProcessing/getDocumentProcessingStatus',
  exportSingleReport: '/api/Document/ExportSingleReport',
  getPOMReportTemplateById: '/api/Template/getPOMReportTemplateById',
  updateIsReadNotifications: '/api/WorkflowAction/UpdateIsReadNotifications',
  updateEmployee: '/api/Document/updateEmployee',
  exportTaskLogData: '/api/WorkFlowDetails/ExportTaskLogData',
  getFolderItem: '/api/Folder/getFolderItem',
  getAllFilesInSystem: '/api/Folder/getAllFiles',
  getSharedItems: '/api/Folder/getSharedItems',
  getMyLibraryItems: '/api/Folder/getMyLibraryItems',
  getSharedFolderItems: '/api/Folder/getSharedFolderItems',
  downloadFolder: '/api/Folder/download/',
  folderManifest: '/api/Folder/manifest/',
  prepareFolderDownload: '/api/Folder/prepare-download/',
  folderDownloadStatus: '/api/Folder/download-status/',
  downloadPreparedFolder: '/api/Folder/download-prepared/',
  getSearchItems: '/api/Dashboard/searchItems',
  getSearchItemsClassic: '/api/Dashboard/searchItemsClassic',
  globalSearch: '/api/Search/search',
  multiDelete: '/api/File/MultiDelete',

  getAllExternalUserAPI: '/api/User/getExternalUsers',

  // USER ACTIVITY
  getAllActions: '/api/UserActivity/getAllActions',
  getActivityLog: '/api/UserActivity/getActivityLog',

  // NEW URLS FOR EVENTS
  getEvents: '/api/Event/getList',
  createEvent: '/api/Event/createEvent',
  updateEvent: '/api/Event/updateEvent',
  deleteEvent: '/api/Event/deleteEvent',
  getEventById: '/api/Event/getById',
  activeEvent: '/api/Event/ActivateEvent',
  deActivateEvent: '/api/Event/DeActivateEvent',

  // NEW URLS FOR DASHBOARD
  getTotalCountStatistics: '/api/Dashboard/TotalCountStatistics',
  getRecentUploads: '/api/Dashboard/RecentUploads',
  getActivityFeed: '/api/Dashboard/ActivityFeed',
  getMySharedItems: '/api/Dashboard/MySharedItems',
  userStorage: '/api/Dashboard/UserStorage',

  // NEW URLS FOR FOLDER
  getFolderHierarchy: '/api/Folder/GetFolderHierarchy',
  getSubFolderHierarchy: '/api/Folder/GetSubFolderHierarchy',
  getDepartmentLibraryFolderHierarchy: '/api/Folder/GetDepartmentLibraryFolderHierarchy',
  getDepartmentLibrarySubFolderHierarchy: '/api/Folder/GetDepartmentLibrarySubFolderHierarchy',
  getDepartmentRootFolderId: '/api/Folder/GetDepartmentRootFolderId',

  // NEW URLS FOR TAGS
  getTags: '/api/Tag/getList',

  // Share
  shareFile: '/api/Share/file',
  shareFolder: '/api/Share/folder',
  revertFileShare: '/api/Share/file/revert',
  revertFolderShare: '/api/Share/folder/revert',
  getAllFileFolderPermissions: '/api/Share/getAllFileFolderPermissions',
  getUserGuide: '/api/UserManual/getusermanual',
  downloadUserGuide: '/api/UserManual/downloadusermanual',
  uploadUserGuide: '/api/UserManual/uploadmanual',
  updateUserGuide: '/api/UserManual/updatemanual',
  getSharedFileUser: '/api/Share/file/shared-users/',
  getSharedFolderUser: '/api/Share/folder/shared-users/',
  getSharedFileDepartments: '/api/Share/file/shared-departments/',
  getSharedFolderDepartments: '/api/Share/folder/shared-departments/',
  updateFileShare: '/api/Share/file/permission',
  updateFolderShare: '/api/Share/folder/permission',
  getViewDownloadLogs: '/api/UserActivity/view-download-logs/',
  validateShareToken: '/api/Share/validate-token',
  processShareLink: '/api/Share/process-link',
  anonymousShare: '/api/AnonymousShare/anonymous-share',
  anonymousShareCurrent: '/api/AnonymousShare/anonymous-share/current',
  // anonymousShareLinks: '/api/AnonymousShare/anonymous-share/links',
  anonymousShareDeactivate: '/api/AnonymousShare/anonymous-share/deactivate',
  anonymousShareVerifyToken: '/api/AnonymousShare/anonymous-share/verifyToken',
  anonymousShareGetFileById: '/api/AnonymousShare/getfileById',
  anonymousShareGetFileByFolderId: '/api/AnonymousShare/getFolderById',
  anonymousShareVerify: '/api/AnonymousShare/anonymous-share/verify',
  anonymousShareDownloadFile: '/api/AnonymousShare/GetFileFromCloud',
  anonymousShareDownloadFolder: '/api/AnonymousShare/download',
  anonymousShareGetMyLibraryItems: '/api/AnonymousShare/getMyLibraryItems',
  removeSharedFolder:'/api/Share/removesharedfolder/',
  removeSharedFile:'/api/Share/removesharedfile/',

  // Favourite
  getMyFavourites: '/api/Favourites/GetMyFavourites',
  addFavourite: '/api/Favourites/Add',
  removeFavourite: '/api/Favourites/Remove',

  // Recycle Bin
  getRecycleBinItems: '/api/File/GetRecycleBin',
  fileRestore: '/api/File/restore',
  deleteForever: '/api/File/DeleteForever',
  getArchivedItems: '/api/File/GetArchivedItems',
  unarchiveItem: '/api/File/Unarchive',
  
  // Browse by Tag and Event
  browseFileByTag: '/api/File/BrowseFileByTag',
  browseFileByEvent: '/api/File/BrowseFileByEvent',
  browseFileByLocation: '/api/File/BrowseFileByLocation',
  // resolveGoToLocation: '/api/File/resolve-location',
  // restoreRecycleBinItem: '/api/File/RestoreRecycleBin',
  // deleteRecycleBinItem: '/api/File/DeleteRecycleBin',
  deleteUserGuide: '/api/UserManual/deletemanual',
  getActiveUserGuide: '/api/UserManual/getactiveusermanual',
  //activateDeactivateUserGuide: (id: number, action: string) => `/api/UserManual/${action}/${id}`,
  activateDeactivateUserGuide: '/api/UserManual/activateordeactivate',

  getAllLocations: '/api/Location/getAllLocations',
  createLocation: '/api/Location/createLocation',
  updateLocation: '/api/Location/updateLocation',
  deleteLocation: '/api/Location/deleteLocation',
  getLocationById: '/api/Location/getById',
  createTag: '/api/Tag/createTag',
  updateTag: '/api/Tag/updateTag',
  deleteTag: '/api/Tag/deleteTag',
  getTagById: '/api/Tag/getTagById',
  activeTag: '/api/Tag/ActivateTag',
  deActivateTag: '/api/Tag/DeActivateTag',

 
  documentAiStatus: '/api/DocumentProcessing/ai/status',
  documentAiProcessFile: '/api/DocumentProcessing/ai/process-file/',
  documentAiQueue: '/api/DocumentProcessing/ai/queue/',
  documentAiProcessingStatus: '/api/DocumentProcessing/ai/processing-status/',
  documentAiResult: '/api/DocumentProcessing/ai/result/',
  documentAiOcr: '/api/DocumentProcessing/ai/ocr/',
  documentAiApplySuggestions: '/api/DocumentProcessing/ai/suggestions/apply',
  documentAiRemoveTag: '/api/DocumentProcessing/ai/tags/remove',
  documentAiJobsFor: '/api/DocumentProcessing/ai/jobs-for',
  documentAiChat: '/api/DocumentAi/chat',
  documentAiQuery: '/api/DocumentAi/query',
};
